import { goal } from "@/content/copy";
import { Eyebrow, Reveal } from "./primitives";

const ids = ["theme-learn", "theme-understand", "theme-perspective"];

export const Goal = () => (
  <section id="goal" data-testid="our-goal-section" className="ph-section scroll-mt-20">
    <div className="ph-container">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <Eyebrow>{goal.eyebrow}</Eyebrow>
          <h2 data-testid="our-goal-heading" className="ph-h2 mt-6">{goal.heading}</h2>
        </Reveal>
        <div className="lg:col-span-6 lg:col-start-7 space-y-6 lg:pt-14">
          {goal.paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.1 * i}>
              <p data-testid={`our-goal-p${i + 1}`} className={i === 0 ? "ph-lead" : "ph-body"}>{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
      <ol className="mt-20 sm:mt-28 border-t ph-rule" aria-label="Three themes">
        {goal.themes.map((t, i) => (
          <Reveal as="li" key={t.title} delay={0.08 * i} className="ph-theme group" >
            <div data-testid={ids[i]} className="grid grid-cols-[auto_1fr] md:grid-cols-12 gap-x-5 gap-y-2 py-8 sm:py-10 items-baseline">
              <span className="ph-theme-num md:col-span-1" aria-hidden="true">{["i", "ii", "iii"][i]}.</span>
              <h3 className="ph-theme-title md:col-span-6">{t.title}</h3>
              <p className="ph-body col-start-2 md:col-start-auto md:col-span-5">{t.text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
